export default __webpack_public_path__ + "static/micki-5210e26cd3950b0c05da11899e08b644.png";